import { Pipe, PipeTransform } from '@angular/core';
import { PlanPreventionEntity } from '../../../data-domains/document-securite/entities/plan-prevention.entity';

@Pipe({
 name: 'actionTitleForPdp'
})

export class ActionTitleForPdpPipe implements PipeTransform {

	transform(pdp: PlanPreventionEntity, args: any[]): string {
	    let title = args[0];
		if (!pdp.parcActif) {
			return 'Le parc est inactif';
		}
		switch (args[0]) {
			case 'Signer':
				if (pdp.etat === 3) {
					title = 'Le PDP est en brouillon';
				}
				break;
			case 'Générer le PDF':
				if (pdp.etat === 3 || pdp.obsolete) {
					title = 'Le PDP est en brouillon ou est archivé';
				}
				break;
			default:
				// rien à faire ici
				break;
		}
		return title;
   }
   
}